// Cross-tab chat synchronization is intentionally disabled.
//
// BroadcastChannel has no confidential addressing: every same-origin tab that
// opens a channel receives the payload before application-side tenant checks
// can run. Chat identifiers and revisions are tenant data, so attaching an
// auth binding and filtering in the receiver is still a disclosure. Keep these
// compatibility functions as fail-closed no-ops until the browser has a
// confidential, session-bound transport.

export function startChatSyncBroadcast() {}

export function subscribeChatSync(_fn) {
    return () => {};
}

export function broadcastChatSynced(_chat) {}

export function broadcastChatDeleted(_chat) {}

export function _resetForTests() {}
